import {
  AuditRecord,
  ReportType,
} from '@trustero/trustero-api-web/lib/audit/audit_pb'

// A closed audit that is still missing its final papers shows "Upload Report".
export const hasPendingAuditReport = (audit: AuditRecord): boolean =>
  audit.getIsClosed() &&
  !audit
    .getReportsList()
    .some((report) => report.getType() === ReportType.CLOSED_AUDIT_FINAL_PAPERS)
